import { useForm, useStore } from '@tanstack/react-form'
import { FF, SearchInputDebounced } from 'ui/components'
import { Select } from 'ui/components/Select'
import { FilterPanel } from 'ui/components/Table'
import { TableFilterRow } from 'ui/temp/TableFilterRow'

import { useDocumentStatusReportContext } from '../../context/reportContext'

import * as SC from './styles'

export const Filter = () => {
  const {
    data: {
      form: { documentName, isAccepted, customerStatus },
      isAcceptedOptions,
      customerStatusOptions
    },
    routeApi
  } = useDocumentStatusReportContext()

  const navigate = routeApi.useNavigate()
  const formApi = useForm({
    defaultValues: { documentName, isAccepted, customerStatus }
  })

  const clearForm = () => {
    formApi.reset()
    navigate({ to: '.', search: undefined, resetScroll: false, replace: true })
  }

  return (
    <FilterPanel isDirty={useStore(formApi.store, (s) => s.isDirty) || false} onReset={clearForm} expanded={false}>
      <SC.FormWrapper>
        <TableFilterRow>
          <SC.FilterWrapper>
            <SC.ItemWrapper>
              <formApi.Field
                name="documentName"
                listeners={{
                  onChange: ({ value }) => {
                    navigate({ to: '.', search: (prev) => ({ ...prev, page: 1, documentName: value }) })
                    return undefined
                  }
                }}
                children={(field) => (
                  <FF
                    label="Document Name"
                    field={field}
                    input={(inputProps) => <SearchInputDebounced {...inputProps} />}
                  />
                )}
              />
            </SC.ItemWrapper>
            <SC.ItemWrapper>
              <formApi.Field
                name="isAccepted"
                listeners={{
                  onChange: ({ value }) => {
                    navigate({ to: '.', search: (prev) => ({ ...prev, page: 1, isAccepted: value }) })
                    return undefined
                  }
                }}
                children={(field) => (
                  <FF
                    label="Is Accepted"
                    field={field}
                    input={(inputProps) => <Select {...inputProps} data={isAcceptedOptions || []} />}
                  />
                )}
              />
            </SC.ItemWrapper>
            <SC.ItemWrapper>
              <formApi.Field
                name="customerStatus"
                listeners={{
                  onChange: ({ value }) => {
                    navigate({ to: '.', search: (prev) => ({ ...prev, page: 1, customerStatus: value }) })
                    return undefined
                  }
                }}
                children={(field) => (
                  <FF
                    label="Customer Status"
                    field={field}
                    input={(inputProps) => <Select {...inputProps} data={customerStatusOptions || []} />}
                  />
                )}
              />
            </SC.ItemWrapper>
          </SC.FilterWrapper>
        </TableFilterRow>
      </SC.FormWrapper>
    </FilterPanel>
  )
}
